import React from "react";
import { Linkedin, Share2 } from "lucide-react";

const ShareLinkedIn = ({ slug, title }) => {
  const onShare = () => {
    const url = encodeURIComponent(`${window.location.origin}/insights/${slug}`);
    const text = encodeURIComponent(title);
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}&text=${text}`,
      "_blank",
      "noopener,noreferrer,width=620,height=560"
    );
  };

  const onNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          url: `${window.location.origin}/insights/${slug}`,
        });
      } catch (_err) {
        // User cancelled the native share sheet — this is normal UX, no action needed.
      }
    } else {
      onShare();
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="article-share">
      <span className="font-mono text-[11px] tracking-overline uppercase text-muted">[ Share ]</span>
      <button
        onClick={onShare}
        data-testid="article-share-linkedin"
        className="inline-flex items-center gap-2 px-4 py-2 border border-black/10 rounded-sm text-[13px] font-semibold text-ink hover:border-ink hover:bg-ink hover:text-white transition-colors"
      >
        <Linkedin className="h-3.5 w-3.5" />
        Share on LinkedIn
      </button>
      <button
        onClick={onNativeShare}
        data-testid="article-share-native"
        className="inline-flex items-center gap-2 px-3 py-2 border border-black/10 rounded-sm text-[13px] font-semibold text-ink hover:border-ink transition-colors md:hidden"
        aria-label="Share"
      >
        <Share2 className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default ShareLinkedIn;
